import builder from '@builder.io/react';
import { BUILDER_API_KEY } from './environment';
import { checkIfCustomer } from './helpers';
import { ShippingCountryState } from './shipping';
import { pickBy } from 'lodash-es';
import { pathWithoutLocale } from './localization';

export const getSharedUserTargetingAttributes = () => {
  const isLoggedIn = checkIfCustomer();
  const countryCode = ShippingCountryState.countryCode ?? 'US';
  const isApp = navigator.userAgent.toLowerCase().includes('aloios');
  const userAgent = isApp ? 'aloios' : navigator.userAgent;
  const { host, device = 'desktop' } = builder.getUserAttributes() ?? {};

  const urlPath = pathWithoutLocale(window.location.pathname);

  return pickBy(
    {
      urlPath,
      host,
      device,
      isLoggedIn,
      countryCode,
      isApp,
      userAgent,
    },
    (value) => value !== null && value !== undefined
  );
};

type BuilderUserAttributeValue = string | number | boolean | string[] | number[] | boolean[] | undefined;

// ? [REVISIT] type this
export const fetchDataFromBuilder = async <T extends unknown>(
  modelname: string,
  { additionalUserAttributes }: { additionalUserAttributes?: Record<string, BuilderUserAttributeValue> } = {}
) => {
  const data: BuilderResponse<T> = await builder.get(modelname, {
    apiKey: BUILDER_API_KEY,

    userAttributes: {
      ...getSharedUserTargetingAttributes(),
      ...pickBy(additionalUserAttributes),
    },
  });

  return data;
};

// Builder Types
export type BuilderResponse<T> = {
  createdBy: string;
  createdDate: number;
  data: T;
  folders: unknown[];
  id: string;
  lastUpdatedBy: string;
  meta: Meta;
  modelId: string;
  name: string;
  published: string;
  query: unknown[];
  testRatio: number;
  variations: Variations;
  lastUpdated: number;
  firstPublished: number;
  rev: string;
  variationId: string;
};

export type Meta = {
  format: string;
  kind: string;
  lastPreviewUrl: string;
  shopifyCustomDomain: string;
  shopifyDomain: string;
};

export type Variations = {};
